import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = ["data-qa"]
const _hoisted_3 = {
  key: 1,
  class: "_mt-3"
}
const _hoisted_4 = {
  class: "gfu-hd gfu-hd--h2 _mt-4",
  "data-qa": "project-description-section:MoreInfoTitle"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_compare_rewards_banner = _resolveComponent("compare-rewards-banner")
  const _component_crowdfunding_reward_card_list = _resolveComponent("crowdfunding-reward-card-list")
  const _component_without_reward_section = _resolveComponent("without-reward-section")
  const _component_content_renderer = _resolveComponent("content-renderer")

  return (_openBlock(), _createElementBlock("div", {
    class: "gfu-layout-wrapper gfu-layout-wrapper--extranarrow gfu-4of5--l gfu-3of5--xl",
    "data-qa": `project-description-section:${$props.sectionID}`
  }, [
    _createElementVNode("h2", {
      ref: "anchor",
      class: "gfu-hd gfu-hd--h2 gfu-heading--top-divider _mb-1",
      "data-qa": `project-description-section-title:${$props.sectionHeader}`
    }, _toDisplayString($props.sectionHeader), 9 /* TEXT, PROPS */, _hoisted_2),
    ($options.showRewardsTable)
      ? (_openBlock(), _createBlock(_component_compare_rewards_banner, { key: 0 }))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_crowdfunding_reward_card_list, {
      rewards: $props.rewards,
      onMounted: $options.onMountedRewardCardList
    }, null, 8 /* PROPS */, ["rewards", "onMounted"]),
    ($options.isCrowdfunding)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_without_reward_section, {
            "project-id": $options.projectID,
            "min-amount": $props.minAmount,
            "max-amount": $props.maxAmount
          }, null, 8 /* PROPS */, ["project-id", "min-amount", "max-amount"])
        ]))
      : _createCommentVNode("v-if", true),
    ($props.sectionContent)
      ? (_openBlock(), _createBlock(_component_content_renderer, {
          key: 2,
          content: $props.sectionContent
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.Resources.Common.MoreInfoHeader), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["content"]))
      : _createCommentVNode("v-if", true)
  ], 8 /* PROPS */, _hoisted_1))
}